// extracted by mini-css-extract-plugin
module.exports = {"no-options-message-text":"sources-select__no-options-message-text___23DfK"};